var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"variant":"primary","title":"Historia","href":_vm.url}},[_c('i',{staticClass:"fas fa-book"})])
}
var staticRenderFns = []

export { render, staticRenderFns }